
const digest = '79cdde2b104c4eb04c4c4d4cd81ed15a083191cbc38229de1d5624bc6ccabf6d';
const classes = {"wrapper":"_wrapper_1mukg_1","item":"_item_1mukg_10","tartar":"_tartar_1mukg_10","plaque":"_plaque_1mukg_10","pus":"_pus_1mukg_10","bleeding":"_bleeding_1mukg_10"};
const css = `._wrapper_1mukg_1 {
  position: absolute;
  top: 6px;
  right: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

._item_1mukg_10, ._tartar_1mukg_10, ._plaque_1mukg_10, ._pus_1mukg_10, ._bleeding_1mukg_10 {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
}

._bleeding_1mukg_10 {
  background-color: rgb(208, 2, 27);
  top: 0;
  right: 0;
}

._pus_1mukg_10 {
  background-color: rgb(248, 231, 28);
  top: 0;
  right: 12px;
}

._plaque_1mukg_10 {
  background-color: rgb(74, 144, 226);
  top: 12px;
  right: 0;
}

._tartar_1mukg_10 {
  background-color: #fff;
  border: 1px solid rgb(188, 193, 204);
  top: 12px;
  right: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  